import { render } from "./PrijaviSe.vue?vue&type=template&id=04d90cf6&scoped=true"
import script from "./PrijaviSe.vue?vue&type=script&lang=js"
export * from "./PrijaviSe.vue?vue&type=script&lang=js"

import "./PrijaviSe.vue?vue&type=style&index=0&id=04d90cf6&scoped=true&lang=css"

import exportComponent from "E:\\Faks Projekti\\ssa_sajt\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d90cf6"]])

export default __exports__